import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
} from "@mui/material";

interface CommentViewPopupProps {
	open: boolean;
	onClose: () => void;
	comment: string | null;
}

const CommentViewPopup: React.FC<CommentViewPopupProps> = ({
	open,
	onClose,
	comment,
}) => {
	const hasHtmlContent = comment && /<[a-z][\s\S]*>/i.test(comment);

	const handleContentClick = (e: React.MouseEvent) => {
		const target = e.target as HTMLElement;
		const anchor = target.closest("a[href]");
		if (anchor) {
			if (e.ctrlKey || e.metaKey) {
				const href = (anchor as HTMLAnchorElement).href;
				if (href && href !== "javascript:void(0)") {
					window.open(href, "_blank", "noopener,noreferrer");
				}
			}
			e.preventDefault();
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>Comment</DialogTitle>
			<DialogContent>
				{comment ? (
					<Box
						onClick={handleContentClick}
						sx={{
							whiteSpace: "pre-wrap",
							maxHeight: 400,
							overflow: "auto",
                            "& .comment-html-content": {
								whiteSpace: "normal",
								wordBreak: "break-word",
							},
							"& table": {
								borderCollapse: "collapse",
								width: "max-content",
								minwidth: '100%',
								margin: "8px 0",
							},
							"& th, & td": {
								border: "1px solid #ddd",
								padding: "8px",
								textAlign: "left",
							},
							"& th": {
								backgroundColor: "#f5f5f5",
							},
                            "& ul, & ol": {
								display: "block",
								margin: "8px 0",
								paddingLeft: "24px",
							},
							"& ul": {
								listStyleType: "disc",
							},
							"& ol": {
								listStyleType: "decimal",
							},
							"& li": {
								display: "list-item",
								margin: "4px 0",
							},
							"& a": {
								color: "#1976d2",
								textDecoration: "underline",
								cursor: "pointer",
							},
							"& a:hover": {
								textDecoration: "underline",
							},
						}}
					>
						{hasHtmlContent ? (
							<div 
                                className="comment-html-content"
                                dangerouslySetInnerHTML={{ __html: comment }} />
						) : (
							<Typography component="pre" sx={{ whiteSpace: "pre-wrap" }}>
								{comment}
							</Typography>
						)}
					</Box>
				) : (
					<Typography color="black">No comment</Typography>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CommentViewPopup;